function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import classNames from 'classnames';
import Button from '../button/Button';
import Icon from '../icon/Icon';
import { STYLE_NONE as BUTTON_STYLE_NONE } from '../button/constants';
import { STYLE_PROP_TYPE, ICON_PROP_TYPE, STYLE_NEUTRAL, STYLE_DARK } from './constants';
import { getAdditionalProps } from '../utils/propTypes';

var IconButton =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(IconButton, _PureComponent);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconButton).apply(this, arguments));
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          title = _this$props.title,
          isActive = _this$props.isActive,
          isDisabled = _this$props.isDisabled,
          isOverImage = _this$props.isOverImage,
          iconType = _this$props.iconType,
          onClick = _this$props.onClick,
          iconColor = _this$props.iconColor;
      var extraAttrs = getAdditionalProps(this);
      var buttonStyle = style;

      if (buttonStyle === STYLE_DARK) {
        buttonStyle = STYLE_NEUTRAL;
      }

      var iconButtonClasses = classNames('eds-icon-button', _defineProperty({
        'eds-icon-button--active': isActive,
        'eds-icon-button--disabled': isDisabled,
        'eds-icon-button--over-image': isOverImage
      }, "eds-icon-button--".concat(buttonStyle), buttonStyle));
      return React.createElement("span", {
        className: iconButtonClasses,
        "data-spec": "icon-button"
      }, React.createElement(Button, _extends({
        style: BUTTON_STYLE_NONE,
        onClick: onClick,
        disabled: isDisabled
      }, extraAttrs), React.createElement(Icon, {
        type: iconType,
        title: title,
        isBlockLevel: true,
        color: iconColor
      })));
    }
  }]);

  return IconButton;
}(PureComponent);

_defineProperty(IconButton, "propTypes", {
  /**
   * The title used to describe icon button
   */
  title: EBPropTypes.translation.isRequired,

  /**
   * Changes the style of the icon button.
   */
  style: STYLE_PROP_TYPE,

  /**
   * The type of icon that you want to display (chunky or third party)
   */
  iconType: ICON_PROP_TYPE,

  /**
  * If the icon button is active
  **/
  isActive: PropTypes.bool,

  /**
  * If the icon button should be set to a disabled state
  **/
  isDisabled: PropTypes.bool,

  /**
  * If the icon button will be shown over an image, use a style that includes a background color for better visibility
  **/
  isOverImage: PropTypes.bool,

  /**
   * Callback function invoked when the button is clicked.
   */
  onClick: PropTypes.func,

  /**
   * Overrides the color of the icon.
   */
  iconColor: PropTypes.string
});

_defineProperty(IconButton, "defaultProps", {
  style: STYLE_NEUTRAL,
  isActive: false,
  isDisabled: false,
  isOverImage: false
});

export { IconButton as default };